import BnumElement from 'components/bnum-element';
import { EVENT_DEFAULT } from 'core/utils/constants/constants';
import { EVENT_BUTTON_CLICK } from './constants';
import { JsEventClick } from './types';

export function OnButtonClickedInitializer(
  event: JsEventClick,
  instance: BnumElement,
) {
  event.add(EVENT_DEFAULT, (clickEvent) => {
    instance.trigger(EVENT_BUTTON_CLICK, {
      innerEvent: clickEvent,
    });
  });
}
